<template>
  <div class="container">
    <app-header title="申请退款" :is-back="isBack" @back="back"/>
    <div class="title">选择服务类型</div>
    <div style="padding: 0 16px;">
      <van-radio-group v-model="form.backType">
        <div class="van-radio">
          <van-radio :name="0" checked-color="#FE003B">未收到货（无需退货，只退款）</van-radio>
        </div>
        <div class="van-radio">
          <van-radio :name="1" checked-color="#FE003B">已收到货（退货退款）</van-radio>
        </div>
      </van-radio-group>
    </div>

    <div class="title">退款原因</div>
    <div class="supplierA" @click="show = true">
      <div class="suhint">请选择退款原因</div>
      <div class="deadd">
        <span style="font-size: 14px; color: #000000;position: relative;top: -3px;">{{form.reason}}</span>
        <img src="@/assets/addgo.png" alt="" width="14px">
      </div>
    </div>
    <div class="refund-money">
      <div class="refund-title">
        <span>退款金额</span>
        <!--<span style="color: #999999;font-size:14px">(点击可以修改金额)</span>-->
      </div>
      <div class="refund-value">
        <input class="refund-input" placeholder="请填写退款金额" v-model="form.backMoney"></input>
      </div>
    </div>
    <div>
      <div class="name">请描述退款原因</div>
      <textarea class="synopsis" placeholder="请填写退款原因" v-model="form.remark"></textarea>
    </div>
    <div class="image" style="display: flex;">
      <div class="item" v-for="(item,index) in fileList" :key="index" style="padding-left: 7px;padding-top: 10px;margin-bottom: 10px;">
        <img :src="item.url"  alt="图片" class="imgPreview" style="width: 80px;height: 80px;">
        <van-icon name="close" @click="delImg(index)" class="delte" style="top: -73px;left: -9px;"/>
      </div>
      <van-uploader style="margin-left: 10px;margin-top: 12px;" :after-read="afterRead" :accept="accept"  upload-icon="plus" />
    </div>
    <div class="submit" @click="submit()">提交</div>

    <!--弹窗-->
    <van-popup v-model="show" round position="bottom" :style="{ height: '50%' }" >
      <div class="popup">
        <div class="popuphead">
          <div class="close" @click="show = false">
            <img src="@/assets/close.png" alt="" width="14px">
          </div>
          <div class="confirm" @click="show = false">确定</div>
        </div>
        <div class="type" @click="selectDesc(item,index)"
             v-for="(item,index) in $enums.RefundReason"
             :key="index"
             :class="active==index?'active':''">
          {{item}}</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import { image } from '@/api/file'
  import { saveShopProblem } from '@/api/mine/shopProblem.js'
  export default {
    name: "refund",
      data(){
        return{
          active: '',
          show:false,
          isBack: false,
          orderStatus: 0,
          accept: 'image/*',
          // 图片列表
          fileList: [],
          total: '',
          form : {
            backType: 0,
            backMoney: 0,
            reason : '请选择',
            uid : '',
            remark : '',
            imageList : '',
            oid : ''
          }
        }
      },
      created(){
        this.form.oid = this.$route.query.orderId
        this.total = this.$route.query.total
        this.form.backMoney = this.$route.query.total
        this.orderStatus = this.$route.query.orderStatus
      },
      methods:{
        back(){
          this.$route.params.orderStatus = this.orderStatus
          this.$router.go(-1)
        },
        selectDesc (desc,index) {
          this.form.reason = desc
          this.active = index
          this.show = false
        },
        afterRead(file) {
          console.log('输出file:',file)
          this.upload(file);
        },
        upload(file){
          let formData = new FormData()
          formData.append('file', file.file)
          image(formData).then(res => {
            if (res.success) {
              this.fileList.push({
                name: file.file.name,
                url: res.data
              }); //上传一张之后压入这个数组
            }else{
              this.$toast.fail(res.msg)
            }
          }).catch(err=>{

          })
        },
        submit () {

          var user = localStorage.getItem('userInfo')
          user = JSON.parse(user)
          if (!user){
            this.$router.push({
              path: '/login'
            })
            return;
          }
          if (this.form.reason=='请选择'){
            this.$toast.fail('请选择退款原因')
            return;
          }
          if (!this.form.backMoney){
            this.$toast.fail('请输入退款金额')
            return;
          }
          if (!this.form.remark){
            this.$toast.fail('请输入描述退款原因')
            return;
          }

          if (parseFloat(this.form.backMoney) > parseFloat(this.total)){
            this.$toast.fail('退款金额不能大于总金额')
            return;
          }

          this.form.uid = user.id
          var images = []
          for (var item of this.fileList) {
            images.push(item.url)
          }
          this.form.imageList = JSON.stringify(images)
          saveShopProblem(this.form).then(response => {
              if (response.code == "200") {
                this.$toast.success('申请成功，等待商家审核')
                this.back();
              } else {
                this.$toast.fail('服务器繁忙，请稍后尝试')
              }
          }).catch(err => {
              console.log(err)
          })
        },
        delImg (index) {
          // 删除指定下标的图片对象
          if (isNaN(index) || index >= this.fileList.length) {
            return false
          }
          let tmp = []
          for (let i = 0, len = this.fileList.length; i < len; i++) {
            if (this.fileList[i] !== this.fileList[index]) {
              tmp.push(this.fileList[i])
            }
          }
          this.fileList = tmp
        }
      },
    }
</script>

<style lang="less" scoped>
  .van-radio{
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 5px;
  }
  .container{
    .title{
      padding: 10px;
      font-size:16px;
      font-family:PingFang SC;
      font-weight:500;
      line-height:22px;
      color:rgba(51,51,51,1);
      opacity:1;
    }
    .supplierA{
      height: 35px;
      width: 95%;
      margin-left: 2%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #F3F3F3;
      .suhint{
        font-size:14px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:20px;
        color:rgba(51,51,51,1);
        opacity:1;
      }
      .deadd{
        color: #C9C9C9;
        font-size: 20px;
      }
    }
    .refund-money{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 10px;
      border-bottom: 1px solid #F3F3F3;
      .refund-value{
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: #FE003B;
      }
      .refund-input{
        border: none;
        text-align: right;
      }
    }
    .name{
      margin-left: 2%;
      font-size:14px;
      font-family:PingFang SC;
      font-weight:400;
      line-height:20px;
      color:rgba(51,51,51,1);
      opacity:1;
      margin-top: 12px;
      margin-bottom: 12px;
    }
    .uploadimg{
      width:85px;
      height:100px;
      background:rgba(246,246,246,1);
      border:1px solid rgba(243,243,243,1);
      opacity:1;
      border-radius:4px;
      margin-top: 20px;
      margin-left: 2%;
      .upload{
        font-size: 35px;
        text-align: center;
        line-height: 100px;
        color: #666666;
      }
    }
    .submit{
      width:95%;
      height:40px;
      margin-top: 145px;
      margin-bottom: 20px;
      margin-left: 2%;
      background:linear-gradient(0deg,rgba(244,4,66,1) 0%,rgba(226,23,75,0.73) 100%);
      opacity:1;
      border-radius:4px;
      line-height: 40px;
      text-align: center;
      font-size:16px;
      font-family:PingFang SC;
      font-weight:400;
      color:rgba(255,255,255,1);
    }
    .synopsis{
      width:90%;
      height:80px;
      background:rgba(255,255,255,1);
      border:1px solid rgba(243,243,243,1);
      opacity:1;
      border-radius:6px;
      margin-left: 2%;
      padding: 10px;
    }
    .popup{
      .popuphead{
        display: flex;
        justify-content: space-between;
      }
      .close{
        color: #C7C7C7;
        font-size: 25px;
        padding: 20px;
      }
      .confirm{
        padding: 20px;
        font-size:14px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:20px;
        color:rgba(254,0,59,1);
        opacity:1;
      }
      .active{
        color:rgba(254,0,59,1)!important;
      }
      .type{
        height: 45px;
        line-height: 45px;
        border-top: 1px solid #DDDDDD;
        font-size:14px;
        font-family:PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        opacity:1;
        text-align: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/order/refund.vue